const menu = [
    {link: '/#/dashboard', title: 'dashboard', icon: 'menu-icon fa fa-tachometer-alt'},
    {
        link: '#', title: 'sifarnici', icon: 'menu-icon fa fa-desktop', children: [
            {link: '/#/artikli', title: 'artikli'},
            {link: '/#/trgovinski-lanci', title: 'trgovinskiLanci'},
            {link: '/#/tipovi-objekata', title: 'tipoviObjekata'},
            {link: '/#/kategorije-objekata', title: 'kategorijeObjekata'},
            {link: '/#/distributeri', title: 'distributeri'},
            {link: '/#/aktivnosti', title: 'aktivnosti'},
            {link: '/#/stalci', title: 'stalci'},
        ],
    },
    {
        link: '/#/objekti', title: 'objekti', icon: 'menu-icon fa fa-shopping-cart'
    },
    {
        link: "#", title: 'posete', icon: 'menu-icon fa fa-taxi', children: [
            {link: '/#/posete', title: 'posete'},
            //{link: '/#/ponovnePosete', title: 'ponovnePosete'},
            {link: '/#/planiranePosete', title: 'planiranePosete'},
            // {link: '/#/komentari', title: 'komentari'}
        ]
    },
    {
        link: "#", title: 'dokumenta', icon: 'menu-icon fa fa-file', children: [
            {link: '/#/narudzbenice', title: 'narudzbenice'},
        ]
    },
    {
        link: "#", title: 'izvestaji', icon: "fa fa-chart-pie", children: [
            {
                title: 'sumarniIzvestaji', subChildren: [
                    {link: '/#/izvestaji/izvestaj-aktivnosti', title: 'izvestajAktivnosti'},
                ]
            },
            /*{
                title: 'promet', subChildren: [
                    {link: '/#/promet-po-distributerima', title: 'prometPoDistributerima'},
                    {link: '/#/promet-poslednja-poseta', title: 'prometIPoslednjaPoseta'}
                ]
            },*/
            {
                title: 'merchandisers', subChildren: [
                    {link: '/#/dnevna-aktivnost-merchandisera', title: 'dnevnaAktivnostMerchandisera'},
                    {link: '/#/mesecni-merchandising-izvestaj', title: 'mesecniMerchandisingIzvestaj'},
                    //{link: '/#/merchandisers-slike-poseta', title: 'merchandisersSlikePoseta'},
                ]
            },
            {link: '/#/izvestaji-abc-analiza-kupaca', title: 'abcAnalizaKupaca'},
            {link: '/#/izvestaji-zalihe', title: 'zalihe'},
            {link: '/#/min-max-stock', title: 'minimalneZalihe'},
        ]
    },
    {
        link: "/#/korisnici", title: 'korisnici', icon: 'fa fa-users',
    }
];

export default menu;
